import styles from './WelcomeLinks.module.css';
import stylesCommon from '../stylesCommon.module.css'
import { IconDownload } from '../../Icons';
import { ComingSoon } from './ComingSoon';
import { GLOBAL_LINKS_BAIXAR_APP, GLOBAL_LINKS_CADASTRE_ENTRAR, GLOBAL_LINKS_USER_SETTINGS } from '../../../pages/global/links';
import { PROXY_SERVER_GET_USER_PHOTO } from '../../../_proxy';


export const openSignIn = () => {
    ComingSoon(
        () => window.open(
            GLOBAL_LINKS_CADASTRE_ENTRAR,
            "_self"
        ), true
    );
}
export const openDownloadApp = (AppDownloadModalRef) => {
    ComingSoon(
        () => {
            const AppDownloadModal = AppDownloadModalRef?.current ?? null
            if (AppDownloadModal && window.screen.width >= 800) {
                AppDownloadModal?.openModal?.()
            } else {
                window.open(
                    GLOBAL_LINKS_BAIXAR_APP,
                    "_blank"
                )
            }

        }, true
    );
}
export const WelcomeLinks = ({
    isAuthenticated,
    userId,
    AppDownloadModalRef
}) => {
    return <>
        <button
            className={`${stylesCommon.Hover} ${styles.Button} ${styles.WhiteButton}`}
            onClick={() => { openDownloadApp(AppDownloadModalRef) }}><IconDownload color='var(--cor_tooMe_2)' />&nbsp;Baixar o App</button>
        {!isAuthenticated ? <button
            className={`${stylesCommon.Hover} ${styles.Button} ${styles.OrangeButton}`}
            onClick={openSignIn}>Entrar</button> :
            <>
                <img
                    className={styles.UserPhoto}
                    src={PROXY_SERVER_GET_USER_PHOTO(userId)}
                    onClick={() => { window.open(GLOBAL_LINKS_USER_SETTINGS, '_self') }}
                />

            </>
        }
    </>
}